import {useQuery} from "@tanstack/react-query";
import {readPurchaseOrderDetail} from "../../../../../api/purchase/PcsApi";
import {pcsDetailInit} from "../state";

type Props = {
    param: { purchaseOrderId: number };
};

export const useReadPurchaseOrderDetail = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPurchaseOrderDetail", param],
        queryFn: async () => await readPurchaseOrderDetail(param),
        select: (res) => res?.data.result ?? pcsDetailInit,
        enabled: param.purchaseOrderId !== 0
    });

    return {data};
};
